<div class="variant-header-container variant-saved">
  <span class="left-part">
    <mat-form-field appearance="fill" class="space-h-l">
      <mat-label>{{ 'STATUT' | translate }}</mat-label>
      <mat-select value="1" disabled>
        <mat-option value="1">{{ creationStatus?.translatedName || 'DRAFT' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </span>
</div>
<form class="new-variant-body" *ngIf="formGroup && selectedYieldUnit && variantLang" [formGroup]="formGroup" (ngSubmit)="createVariant()">
  <div class="flex-row">
    <div class="space-h-xxl">
      <h1 class="space-v-l">{{ 'VARIANTS.NEW_VARIANT.ADD' | translate }}</h1>
      <app-form-yield
        [formGroup]="formGroup"
        [yieldUnits]="yieldUnitsListArray"
        [lang]="variantLang"
        [market]="variantMarket"
      ></app-form-yield>
    </div>
    <div class="space-l-xxl">
      <h1 class="space-v-l">{{ 'VARIANTS.NEW_VARIANT.DUPLICATING' | translate }}</h1>
      <mat-radio-group formControlName="duplicateVariant" class="variants-radio-group" name="variants-radio-group">
        <mat-radio-button
          *ngFor="let variant of existingVariants"
          [value]="variant.id"
          id="RecipesModifyVariantDuplicateRadioBtn"
          class="space-v-m"
          ><span id="RecipesModifyVariantDuplicateVariantLbl">{{ variant.label }}</span></mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>
  <div>
    <button
      type="submit "
      id="RecipesModifyVariantAddSaveBtn"
      mat-button
      class="btn btn-submit"
      [disabled]="formGroup ? formGroup.invalid : true"
    >
      {{ 'VARIANTS.SAVE_VARIANT' | translate }}
    </button>
  </div>
</form>
